// extracted by mini-css-extract-plugin
export default {"melodyVideo":"OL-z","isFullWidth":"PL-z","landingPageVideo":"QL-z","play":"RL-z","iframeVideo":"SL-z","playHidden":"TL-z","fullwidth":"UL-z"};